<template>
  <div class="w-full flex-grow flex flex-col overflow-y-auto h-screen pb-60">
    <div class="grid grid-cols-6 md:grid-cols-12 gap-8 w-full p-4">
      <div class="col-span-6 md:col-span-4 flex flex-col">
        <h1 class="mb-4 font-bold">Apply filters</h1>
        <div class="flex flex-row items-center input-box">
          <input
            type="checkbox"
            id="include-credit"
            v-model="userFilters.includeCredit"
            class="mr-2"
          />
          <label for="include-credit">Include Credit</label>
        </div>
        <div class="flex flex-row items-center input-box">
          <input
            type="checkbox"
            id="include-created-by-seller"
            v-model="userFilters.includeCreatedBySeller"
            class="mr-2"
          />
          <label for="include-created-by-seller"
            >Include Created by Seller</label
          >
        </div>
        <div class="flex flex-row items-center input-box">
          <input
            type="checkbox"
            id="include-created-by-user"
            v-model="userFilters.includeCreatedByUser"
            class="mr-2"
          />
          <label for="include-created-by-user">Include Created by user</label>
        </div>
        <div class="flex flex-col input-box">
          <h4>Group Orders by</h4>
          <div class="flex flex-row items-center">
            <input
              type="checkbox"
              name="groupByDay"
              id="groupByDay"
              @change="userFilters.groupOrdersby = 'day'"
              :checked="userFilters.groupOrdersby == 'day'"
              class="mr-2"
            />
            <label for="groupByDay">Day</label>
          </div>
          <div class="flex flex-row items-center">
            <input
              type="checkbox"
              name="groupByMonth"
              id="groupByMonth"
              @change="userFilters.groupOrdersby = 'month'"
              :checked="userFilters.groupOrdersby == 'month'"
              class="mr-2"
            />
            <label for="groupByMonth">Month</label>
          </div>
        </div>
        <div class="flex flex-col input-box">
          <label for="name">Filter by seller</label>
          <select
            class="default-select bordered full"
            name="seller"
            id="seller"
            placeholder="filter by seller"
            v-model="userFilters.sellerSelected"
          >
            <option value="">All sellers</option>
            <option
              v-for="seller in sellers.options"
              :value="seller.value"
              :key="seller.value"
            >
              {{ seller.label }}
            </option>
          </select>
        </div>
        <div class="flex flex-col input-box">
          <label for="from-date">
            from date
          </label>
          <input
            type="date"
            class="regular bordered full"
            name="from-date"
            id="from-date"
            v-model="userFilters.fromDate"
          />
        </div>
        <div class="flex flex-col input-box">
          <label for="to-date">
            To date
          </label>
          <input
            type="date"
            class="regular bordered full"
            name="to-date"
            id="to-date"
            v-model="userFilters.toDate"
          />
        </div>
        <div class="flex flex-col input-box">
          <h4>Range Quick Filters</h4>
          <div class="flex flex-col">
            <button
              class="btn btn-info-button justify-center my-1"
              v-for="(range, index) in rangeFilters"
              :class="{
                'bg-green-500':
                  range.fromDate === userFilters.fromDate &&
                  range.toDate === userFilters.toDate
              }"
              :key="index"
              @click="setDateRange(range.fromDate, range.toDate)"
            >
              {{ range.label }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-span-6 md:col-span-8">
        <!-- <BaseLoading :loading="true" v-if="loading" /> -->
        <div
          class="w-full h-80 flex justify-center items-center"
          v-if="loading"
        >
          <BaseSmallSpinner />
        </div>
        <template v-else>
          <BarChart
            v-if="!loading"
            :labels="chart2Labels"
            :chartData="chart2Data"
          ></BarChart>
          <div>
            <h2>Summary</h2>
            <table class="default-table">
              <tbody>
                <tr>
                  <td>
                    Orders Qty
                  </td>
                  <td>{{ ordersQty }} orders</td>
                </tr>
                <tr>
                  <td>
                    Total Products
                  </td>
                  <td>
                    {{ totalProducts | currencyFormatted(true) }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Total Amount
                  </td>
                  <td>
                    {{ totalAmount | currencyFormatted(true) }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Qty of Items
                  </td>
                  <td>{{ qtyItems }} items</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import BarChart from "@/components/BarChart.vue";
import { loadStatistics } from "@/api/store/OrdersService.js";
const today = moment().format("YYYY-MM-DD");
const yesterday = moment()
  .subtract(1, "days")
  .format("YYYY-MM-DD");
const daysAgo7 = moment()
  .subtract(7, "days")
  .format("YYYY-MM-DD");
const daysAgo30 = moment()
  .subtract(30, "days")
  .format("YYYY-MM-DD");
const lastMonthFirstDay = moment()
  .subtract(1, "month")
  .startOf("month")
  .format("YYYY-MM-DD");
const lastMonthLastDay = moment()
  .subtract(1, "month")
  .endOf("month")
  .format("YYYY-MM-DD");
const currentMonthLastDay = moment()
  .endOf("month")
  .format("YYYY-MM-DD");
const currentMonthFirstDay = moment()
  .startOf("month")
  .format("YYYY-MM-DD");
const currentYearFirstDay = moment()
  .startOf("year")
  .format("YYYY-MM-DD");
const currentYearLastDay = moment()
  .endOf("year")
  .format("YYYY-MM-DD");
const lastYearLastDay = moment()
  .subtract(1, "year")
  .endOf("year")
  .format("YYYY-MM-DD");
const lastYearFirstDay = moment()
  .subtract(1, "year")
  .startOf("year")
  .format("YYYY-MM-DD");
const oneYearFromToday = moment()
  .subtract(1, "year")
  .format("YYYY-MM-DD");

export default {
  name: "StatisticsPage",
  components: {
    BarChart
  },
  data() {
    return {
      ordersQty: 0,
      totalProducts: 0,
      totalAmount: 0,
      qtyItems: 0,
      loading: true,
      userFilters: {
        sellerSelected: "",
        fromDate: daysAgo30,
        toDate: today,
        includeCredit: true,
        includeCreatedByUser: true,
        includeCreatedBySeller: true,
        groupOrdersby: "day"
      },
      chart2Labels: null,
      chart2Data: [
        {
          label: "Products",
          backgroundColor: "rgba(26,179,148,0.5)",
          borderColor: "rgba(26,179,148,0.7)",
          pointBackgroundColor: "rgba(26,179,148,1)",
          pointBorderColor: "#fff",
          data: []
        },
        {
          label: "Total Order",
          backgroundColor: "rgba(220, 220, 220, 0.5)",
          pointBorderColor: "#fff",
          data: []
        }
      ]
    };
  },
  watch: {
    userFilters: {
      handler() {
        this.getData();
      },
      deep: true
    }
  },
  computed: {
    rangeFilters() {
      return [
        {
          label: "Today",
          fromDate: today,
          toDate: today
        },
        {
          label: "Yesterday",
          fromDate: `${yesterday}`,
          toDate: `${yesterday}`
        },
        {
          label: "Last 7 days",
          fromDate: daysAgo7,
          toDate: today
        },
        {
          label: "Last 30 days",
          fromDate: daysAgo30,
          toDate: today
        },
        {
          label: "This month",
          fromDate: currentMonthFirstDay,
          toDate: currentMonthLastDay
        },
        {
          label: "Last month",
          fromDate: lastMonthFirstDay,
          toDate: lastMonthLastDay
        },
        {
          label: "This year",
          fromDate: currentYearFirstDay,
          toDate: currentYearLastDay
        },
        {
          label: "Last year",
          fromDate: lastYearFirstDay,
          toDate: lastYearLastDay
        },
        {
          label: "Last 365 days",
          fromDate: oneYearFromToday,
          toDate: today
        },
        {
          label: "Lifetime",
          fromDate: `1900-01-01`,
          toDate: today
        }
      ];
    },
    sellers() {
      return {
        options: this.$store.getters["general/getSellers"].map(seller => {
          return {
            label: seller.name,
            value: seller.email
          };
        })
      };
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const filters = {
        orderType: {
          web: true,
          seller: true
        },
        includeCreatedByUser: this.userFilters.includeCreatedByUser,
        includeCreatedBySeller: this.userFilters.includeCreatedBySeller,
        includeCredit: this.userFilters.includeCredit,
        groupOrdersby: this.userFilters.groupOrdersby,
        seller: this.userFilters.sellerSelected,
        fromDate: this.userFilters.fromDate,
        toDate: this.userFilters.toDate
      };

      loadStatistics(filters).then(res => {
        this.chart2Data[0].data = res.productsTotal;
        this.chart2Data[1].data = res.total;
        this.chart2Labels = res.dates;
        this.ordersQty = res.summary.totalOrdersQty;
        this.totalProducts = res.summary.totalProductsAmount;
        this.totalAmount = res.summary.total;
        this.qtyItems = res.summary.totalProductsqty;
        this.loading = false;
      });
    },
    setDateRange(fromDate, toDate) {
      this.userFilters.fromDate = fromDate;
      this.userFilters.toDate = toDate;
    }
  }
};
</script>
<style lang="postcss" scoped>
label {
  font-weight: 800;
}
</style>
